export const getQueryParam = (param) => {
  const currentURL = window.location.href
  const urlObject = new URL(currentURL)
  const value = urlObject.searchParams.get(param)

  return value
}